import VcomProvider from '../../../../../VcomProvider';
import HttpService from '~/zf/frontend/common/http/HttpService';
import { UserDefinedAlarmEndpoint } from '../const/UserDefinedAlarmEndpoint';
import { BatteryChargeEndpoint } from '../const/BatteryChargeEndpoint';

export default {
  async loadCustomAlarms(systemId = VcomProvider.adminSystemId, groupId = undefined) {
    const response = await HttpService.get(UserDefinedAlarmEndpoint.LOAD_MANY, {
      params: {
        systemId,
        groupId,
      },
    });
    return response.data;
  },
  async loadBatteryStateOfChargeAlarm(systemId = VcomProvider.adminSystemId) {
    const response = await HttpService.get(BatteryChargeEndpoint.LOAD, {
      params: {
        systemId,
      },
    });
    return response.data;
  },
  async loadDevices(systemId = VcomProvider.adminSystemId) {
    const response = await HttpService.get(UserDefinedAlarmEndpoint.LOAD_DEVICES, {
      params: { systemId },
    });
    return response.data;
  },
  async setCustomAlarmStatus(groupId, status) {
    await HttpService.post(
      UserDefinedAlarmEndpoint.SET_STATUS,
      {
        systemId: VcomProvider.adminSystemId,
        groupId,
        status,
      },
    );
  },
  async delete(customAlarmId) {
    const response = await HttpService.post(
      UserDefinedAlarmEndpoint.DELETE,
      {
        systemId: VcomProvider.adminSystemId,
        customAlarmId,
      },
    );
    return response.data;
  },
  async saveCustomAlarm(payload) {
    const response = await HttpService.post(UserDefinedAlarmEndpoint.SAVE, {
      systemId: VcomProvider.adminSystemId,
      ...payload,
    });
    return response.data;
  },
};
